module.exports = __webpack_public_path__ + "static/media/IMG_6442.e91621bc.JPG";